import React, { useMemo, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import UserInspectionProductDetail from "./UserInspectionProductDetail";
import { fromBmarkenDateToDateTime } from "../utils/utils";

function safeTime(v) {
  if (!v) return 0;
  const t = new Date(v).getTime();
  return Number.isFinite(t) ? t : 0;
}

const cellStyle = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

export default function UserInspectionPlays({ plays, onShowTransactions }) {
  const [onlyWinners, setOnlyWinners] = useState(false);

  const filteredAndSorted = useMemo(() => {
    const list = [...(plays || [])];

    const filtered = onlyWinners
      ? list.filter((p) => {
          const r = (p.play_result || "").toString().toUpperCase().trim();
          return r === "WINNER";
        })
      : list;

    filtered.sort((a, b) => {
      const tb = safeTime(b.created_at) || safeTime(b.play_date);
      const ta = safeTime(a.created_at) || safeTime(a.play_date);
      return tb - ta;
    });

    return filtered;
  }, [plays, onlyWinners]);

  return (
    <div style={{ width: "100%" }}>
      <Box mb={1}>
        <FormControlLabel
          control={
            <Checkbox
              checked={onlyWinners}
              onChange={(e) => setOnlyWinners(e.target.checked)}
              color="primary"
            />
          }
          label="Vincite"
        />
      </Box>

      {/* Header */}
      <Box
        display="flex"
        alignItems="center"
        style={{
          padding: "8px 16px",
          borderBottom: "1px solid rgba(0,0,0,0.12)",
        }}
      >
        <Box flex={2} pr={2}>
          <Typography variant="h6">Data</Typography>
        </Box>
        <Box flex={2} pr={2}>
          <Typography variant="h6">Lotto</Typography>
        </Box>
        <Box flex={3} pr={2}>
          <Typography variant="h6">Business</Typography>
        </Box>
        <Box flex={3} pr={2}>
          <Typography variant="h6">Esito</Typography>
        </Box>
        <Box flex={2} pr={2}>
          <Typography variant="h6">Premio</Typography>
        </Box>
        <Box width={40} />
      </Box>

      {filteredAndSorted.map((p, i) => {
        const data = fromBmarkenDateToDateTime(p.created_at);
        const lotto = p.batch_id ?? "-";
        const business = p.business_name ?? "-";
        const esito = p.play_result ?? "-";
        const premio = p.play_prize ?? "-";

        return (
          <Accordion key={p.id || i} square>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Box display="flex" alignItems="center" width="100%">
                <Box flex={2} pr={2} style={cellStyle}>
                  <Typography>{data}</Typography>
                </Box>
                <Box flex={2} pr={2} style={cellStyle}>
                  <Typography>{lotto}</Typography>
                </Box>
                <Box flex={3} pr={2} style={cellStyle}>
                  <Typography>{business}</Typography>
                </Box>
                <Box flex={3} pr={2} style={cellStyle}>
                  <Typography>{esito}</Typography>
                </Box>
                <Box flex={2} pr={2} style={cellStyle}>
                  <Typography>{premio}</Typography>
                </Box>
              </Box>
            </AccordionSummary>

            <AccordionDetails style={{ display: "block" }}>
              <Box pl={4} pr={1} width="100%">
                <UserInspectionProductDetail
                  item={p}
                  onShowTransactions={onShowTransactions}
                />
              </Box>
            </AccordionDetails>
          </Accordion>
        );
      })}
    </div>
  );
}
